export default "__VITE_ASSET__5798109c__"